import { createActions } from 'redux-actions';
import { CorporateHealthClaim } from '@models/CorporateHealthClaim';
import { GetCorporateHealthClaimParams } from '@apis/CorporateHealthClaimApi';

export type State = {
  corporateHealthClaim: CorporateHealthClaim | null | undefined;
};
export type CorporateHealthClaimFetchPayload = GetCorporateHealthClaimParams;
export type StateUpdatePayload = Partial<State>;

export const {
  corporateHealthClaimFetch,

  stateUpdate,
} = createActions(
  'CORPORATE_HEALTH_CLAIM_FETCH',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_CLAIM_DETAILS_CORPORATE_HEALTH_CLAIM_DETAILS',
  },
);
